import os from 'os';

/**
 * 問い合わせ番号採番
 * 問い合わせ番号は12桁で構築する
 * A. 例外生成日時に0年01月01日から1970年01月01日の補正を加えた11桁
 * B. 実行ホスト名の末尾1桁
 * A + B の結合した問い合わせ番号を提供する
 * 19476088154 + samplehost210152 = 194760881542
 * @param hostname
 * @param hostname
 * @see {@link https://doda-git/gitbucket/doda.site/doda-backend/blob/master/doda-web/src/main/java/jp/co/inte/doda/web/common/action/error/CommonErrSendAction.java#L244-L252}
 * @returns 問い合わせ番号
 */
export function numberingInquiryCode(hostname: string) {
  // IDの算出
  // ～1970年01月01日までのミリ秒単位時間
  const correctionData = 635033952000000000;
  const unexpectedHostName = '0';
  const correctionTime = String(Date.now() + correctionData);
  const idLength = 11;
  const endNum = hostname ? getLastDigit(hostname) : unexpectedHostName;
  return correctionTime.substring(correctionTime.length - idLength) + endNum;
}

/**
 * 文字列中の数字末尾を取得する
 * @param text
 * @returns
 */
function getLastDigit(text: string): string {
  return text.replace(/\D/g, '').slice(-1);
}

/**
 * システムエラー画面のURLを作成する
 * @param code エラーコード
 * @returns url
 */
export function getErrorScreenPath(code?: number | string) {
  let serverHostName = '';
  try {
    // server用処理
    serverHostName = os.hostname();
    // eslint-disable-next-line no-empty
  } catch (error) {}
  const errorCode = numberingInquiryCode(serverHostName);
  return `/DodaCommon/system/SystemErr.action?systemCode=F&inquiryCode=${
    code ?? errorCode
  }&errCode=error.system`;
}

/**
 * リビルド前の画面に振り分けるためのURLを作成する
 * @param resolvedUrl
 * @returns url
 */
export const getOldDodaPath = (resolvedUrl: string) => {
  const separator = resolvedUrl.includes('?') ? '&' : '?';
  const oldDodaParam = separator + process.env.OLD_DODA_PARAM;
  const path = resolvedUrl + oldDodaParam;
  return path;
};
